import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { randomUUID } from '@matap/shared';
import CacheStorage from '../cache/cache.storage';

export interface Alert {
  id: string;
  message: string;
  type: 'fancy' | 'quick';
  onYes?: () => void;
  onNo?: () => void;
  onClose?: () => void;
  duration?: number;
  mode?: 'error' | 'warn' | 'info';
}
const reducer = createSlice({
  name: 'general.reducer',
  initialState: {
    alerts: [] as Alert[],
    firstLogin: true,
    fcmToken: null as string,
    cookie: null as string,
  },
  reducers: {
    actionShowAlert(state, action: PayloadAction<string | Omit<Alert, 'id'>>) {
      const payload: Alert =
        typeof action.payload === 'string' ? { message: action.payload, type: 'quick', mode: 'error', id: randomUUID() } : { ...action.payload, id: randomUUID() };

      if (state.alerts.some((a) => a.message === payload.message)) {
        return;
      }

      state.alerts = [...state.alerts, payload];
    },
    actionRemoveAlert(state, action: PayloadAction<string>) {
      state.alerts = state.alerts.filter((a) => a.id !== action.payload);
    },
    actionClearAllAlerts(state) {
      state.alerts = [];
    },
    actionLogOut(state) {
      CacheStorage.clear();
      state.firstLogin = true;
    },
    actionSetFirstLogin(state, action: PayloadAction<boolean>) {
      state.firstLogin = action.payload;
      CacheStorage.set('first-login', String(action.payload));
    },
    actionSetFCMToken(state, action: PayloadAction<string>) {
      state.fcmToken = action.payload;
    },
  },
});

export const { actionShowAlert, actionRemoveAlert, actionLogOut, actionSetFCMToken, actionSetFirstLogin, actionClearAllAlerts } = reducer.actions;
export default reducer.reducer;
